import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  /**
   * Get cookie
   * @method getCookie
   * @returns {string} cookie
   */
  getCookie(name: string) {
    return document.cookie.split(';').some((c) => {
      return c.trim().startsWith(name + '=');
    });
  }

  /**
   * Save cookie
   * @method saveCookie
   * @param cookie cookie
   */
  saveCookie(name, value, days?) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = `${name}=${
      value || ''
    }${expires};path=/;domain=.brandvno.com;Secure;SameSite=None;`;
  }

  /**
   * Destroy cookie
   * @method destroyCookie
   */
  destroyCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.brandvno.com`;
  }
}
